import React, {useState,useEffect,useContext} from "react";
import { Modal } from "react-bootstrap";
import { useTranslate } from 'react-redux-multilingual'
import { IsAuthContext } from 'app/App';
import axios from 'axios'
import swal from "sweetalert2";
import {constructionDocument} from '@gull'

const useLoad = () => {
    const [loading,setLoading]=useState(true)
    const [error,setError]=useState(false)
    const [articleFields,setArticleFields]=useState([])
    const [articleFields_id,setArticleFields_id] = useState([])
    const [customFields,setCustomFields]=useState([])
    let infoException=[
        'id',
        'created_at',
        'updated_at',
        'custom_fields',
        'company_id',
        'kill_promo',
        'archive',
        'provisoire',
        'create_from',
        'last_date_buy',
        'last_pr_devise',
        'transform',
        'to_prepare',
        'indice',
        'on_demand'
    ]

    useEffect(function () { // Custom fields
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/custom_fields/all/article"
            ).then((response) => {
                let arr = []
                response.data.datas.map(value=>{
                    arr.push(value.name)
                })
                setCustomFields(arr)
            }).catch((error) => {
                if(error=='end_session') return;
                setLoading(false)
                setError(true)
            })
        })()
    }, [])

    useEffect(function () { // Article fields
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/get_article_fields"
            ).then((response) => {
                let arr = []
                let arr_id = []
                response.data.datas.map(value=>{
                    if(!infoException.includes(value)){
                        if(value.includes('_id')){
                            arr.push(value.replace('_id',''))
                            arr_id.push(value.replace('_id',''))//On met tous les champs qui ont _id à la fin car pour shopnc ces champs là doivent etre envoyé au back avec la terminaison .name
                        }else{
                            arr.push(value)
                        }
                    }
                })
                setArticleFields(arr)
                setArticleFields_id(arr_id)
            }).catch((error) => {
                if(error=='end_session') return;
                setLoading(false)
                setError(true)
            })
        })()
    }, [])

    return [loading,error,articleFields,customFields,articleFields_id]
}

const DocumentSortAndGroup = (props) =>{
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);

    const [loading,error,articleFields,customFields,articleFields_id] = useLoad()

    const [field,setField]=useState((props.allInfos.sort!=null)?props.allInfos.sort:'')
    const [ascending,setAscending]=useState((props.allInfos.ascending!==null)?(props.allInfos.ascending?'asc':'desc'):'asc')
    const [group,setGroup]=useState((props.allInfos.grouping!=null)?(props.allInfos.grouping.endsWith('.name') ? props.allInfos.grouping.slice(0, -5) : props.allInfos.grouping):'')

    const [validButton,setValidButton] = useState(false)

    const closeModal = () =>{ // Fermeture modal
        props.setShowSortAndGroup(false)
    }

    const handleShow = () => { // Affichage modal
        props.setShowSortAndGroup(true)
    }

    const callBackConstruct = (response) => {
        return true
    };

    const submitConfig = async () => {

        let value_field=''
        if(articleFields_id.includes(field)){
            //Si la valeur id fait parti de la liste, il faut ajouter .name en terminaison pour le back
            value_field = field+'.name'
        }else{
            value_field = field
        }

        let value_group=''
        if(articleFields_id.includes(group)){
            //Si la valeur id fait parti de la liste, il faut ajouter .name en terminaison pour le back
            value_group = group+'.name'
        }else{
            value_group = group
        }

        let obj = {
            sort: value_field,
            ascending: (ascending=='asc')?true:false,
            group: value_group,
        }
        
        constructionDocument(setValidButton,props.id,callBackConstruct,t,obj,props.setItemsBilling,props.setAllInfos,false,props.setDatasPdf)
    }

    const getValueTranslation = (value) => {
        switch (true) {
            case value === 'havestock':
                return t('itemWithStock');
            case value === 'name':
                return t('itemName');
            case value === 'price_b2b':
                return t('b2bPrice');
            case value === 'last_buy_price':
                return t('last_purchase_price');
            case value === 'last_buy_price_devise':
                return t('last_purchase_price_devise');
            case value === 'last_devise':
                return t('devise_achat');
            case value === 'tgc':
                return t('tgc',{taxe:authParam.company.nomenclature_tgc});
            case value.includes('/'): // énuméré de conditionnement
                const [first, second] = value.split('/');
                return t(first) +' '+ second;
            default:
                return t(value) || value;
        }
    };

    //pour assombrir la modal du document
    useEffect(function (){
        if(props.setBrownDocumentModal){
            if(props.showSortAndGroup) props.setBrownDocumentModal(true)
            else props.setBrownDocumentModal(false)
        }
    },[props.showSortAndGroup])
    //end
    
    return(<>
            <Modal show={props.showSortAndGroup} onHide={() => closeModal()}>
                <Modal.Header closeButton className="d-flex flex-wrap">
                    <Modal.Title>{t('sortAndGroup')}</Modal.Title><br />
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-4">
                        <label>{t('sortField')}</label>
                        <div className="col-5">
                            <select 
                                disabled={validButton}
                                className='form-control' 
                                value={field}
                                onChange={(e) => setField(e.target.value)}
                            >
                                <option value="">-- Select --</option>
                                {[...articleFields,...customFields].map(value=>{
                                    return(
                                        <option key={value} value={value} >
                                            {getValueTranslation(value)}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="col-5">
                            <select 
                                disabled={validButton}
                                className='form-control' 
                                value={ascending}
                                onChange={(e) => setAscending(e.target.value)}
                            >
                                <option value="asc">{t('ascending')}</option>
                                <option value="desc">{t('descending')}</option>
                            </select>
                        </div>
                        <div className="col-2">
                            <button
                                type="button"
                                disabled={validButton}
                                className="btn btn-sm btn-primary"
                                onClick={()=>submitConfig()}
                            >
                                {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                            </button>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <label>{t('groupField')}</label>
                        <div className="col-10">
                            <select 
                                disabled={validButton}
                                className='form-control' 
                                value={group}
                                onChange={(e) => setGroup(e.target.value)}
                            >
                                <option value="">-- Select --</option>
                                {[...articleFields,...customFields].map(value=>{
                                    return(
                                        <option key={value} value={value} >
                                            {getValueTranslation(value)}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="col-2">
                            <button
                                type="button"
                                disabled={validButton}
                                className="btn btn-sm btn-primary"
                                onClick={()=>submitConfig()}
                            >
                                {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {props.notButton ?
                    <div onClick={()=>handleShow()}>{t(props.nameBtn)}</div>
                :
                    <div className={`btn btn-sm ${props.showSortAndGroup ? 'btn-primary' : 'btn-outline-primary'}`} onClick={()=>handleShow()}>{t(props.nameBtn)}</div>
            }
        </>
    )
}

export default DocumentSortAndGroup;

